import React, { } from 'react'
import Posts from "./Posts"


export default function Updates({ location, navigate }) {
    return <Posts contentsName={"Updates"} location={location} navigate={navigate} />
}